import { PresetModelContext } from 'context/preset-model/PresetModelContext'
import { useContext, useState } from 'react'
import { TreeItem } from 'react-sortable-tree'
import { RemoveAbleItemProps } from 'ts/interfaces'

export const useRemoveableItem = (setTreeState?: (tree: TreeItem[]) => void) => {
    const [removeableItem, setRemoveableItem] = useState<RemoveAbleItemProps | null>()
    const { setState: setPresetModelState } = useContext(PresetModelContext)

    const handleRemoveSubmit = (tree: TreeItem[]) => {
        if (setTreeState) {
            setTreeState(tree)
        }
        setPresetModelState((prev) => ({
            ...prev,
            hasChanges: true,
            treeState: tree,
            reRenderForm: true,
            reRenderTree: true // Because it is possible that has_descendants color needs to be removed from parent nodes
        }))
    }

    return {
        removeableItem,
        setRemoveableItem,
        handleRemoveSubmit
    }
}
